var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyCourseBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 171,
    viewBox: "0 0 1280 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2199",
    "data-name": "Rectangle 2199",
    width: 1280,
    height: 171,
    transform: "translate(0 105)",
    fill: "#cde1f7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.239,
    cy: 0.292,
    r: 1.75,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#dceaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3dbff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33637",
    "data-name": "Group 33637",
    transform: "translate(0 -105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2208",
    "data-name": "Rectangle 2208",
    width: 1280,
    height: 648,
    transform: "translate(0 -146)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33635",
    "data-name": "Group 33635",
    transform: "translate(1480.341 -792.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33612",
    "data-name": "Group 33612",
    transform: "translate(-845.584 937.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33609",
    "data-name": "Group 33609",
    transform: "translate(6.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36566",
    "data-name": "Path 36566",
    d: "M977.318,564.009l-11.328-3.846a2.288,2.288,0,0,1-1.431-2.9h0a2.288,2.288,0,0,1,2.9-1.431l11.328,3.846a2.288,2.288,0,0,1,1.431,2.9h0A2.288,2.288,0,0,1,977.318,564.009Z",
    transform: "translate(-962.947 -525.977)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36567",
    "data-name": "Path 36567",
    d: "M972.728,577.524,961.4,573.678a2.288,2.288,0,0,1-1.431-2.9h0a2.288,2.288,0,0,1,2.9-1.431l11.328,3.846a2.288,2.288,0,0,1,1.431,2.9h0A2.288,2.288,0,0,1,972.728,577.524Z",
    transform: "translate(-959.847 -535.107)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36568",
    "data-name": "Path 36568",
    d: "M967.136,482.088h0c.012.037.023.075.036.112a31,31,0,0,1,1.123,11.607l12.153,4.012a31.005,31.005,0,0,1,7.813-8.658l.095-.069h0q.5-.357.964-.758a13.809,13.809,0,1,0-22.507-7.43C966.9,481.305,967.011,481.7,967.136,482.088Z",
    transform: "translate(-964.326 -464.074)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36569",
    "data-name": "Path 36569",
    d: "M966.524,583.766a5.454,5.454,0,0,0,9.949,3.378Z",
    transform: "translate(-964.352 -544.932)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36570",
    "data-name": "Path 36570",
    d: "M982.986,530.995l3.612-10.943a2.054,2.054,0,1,0-2.6,1.307l4.334,1.43",
    transform: "translate(-975.213 -500.066)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36571",
    "data-name": "Path 36571",
    d: "M998.494,538.525l3.612-10.943a2.054,2.054,0,1,1,1.307,2.595l-4.334-1.431",
    transform: "translate(-985.955 -506.024)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33610",
    "data-name": "Group 33610",
    transform: "translate(35.537 16.729)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    x2: 3.66,
    y2: 1.208,
    transform: "translate(2.561 5.187)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    y1: 0.575,
    x2: 3.811,
    transform: "translate(4.239)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    x2: 2.72,
    y2: 2.731,
    transform: "translate(0 9.141)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33611",
    "data-name": "Group 33611",
    transform: "translate(0 3.261)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_256",
    "data-name": "Line 256",
    x1: 3.66,
    y1: 1.208,
    transform: "translate(0.447 6.227)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_257",
    "data-name": "Line 257",
    x1: 2.72,
    y1: 2.731,
    transform: "translate(2.785)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_258",
    "data-name": "Line 258",
    x1: 3.811,
    y2: 0.575,
    transform: "translate(0 12.137)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 9.543,
    cy: 9.543,
    rx: 9.543,
    ry: 9.543,
    transform: "translate(-377.995 999.701)",
    fill: "none",
    stroke: "#fa8231",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_279",
    "data-name": "Ellipse 279",
    cx: 9.543,
    cy: 9.543,
    r: 9.543,
    transform: "translate(-992.455 970.901)",
    fill: "none",
    stroke: "#fa8231",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_306",
    "data-name": "Ellipse 306",
    cx: 5.496,
    cy: 5.496,
    r: 5.496,
    transform: "translate(-903.927 981.521)",
    fill: "none",
    stroke: "#fa8231",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_307",
    "data-name": "Ellipse 307",
    cx: 5.496,
    cy: 5.496,
    r: 5.496,
    transform: "translate(-848.08 1003.521)",
    fill: "none",
    stroke: "#fa8231",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_281",
    "data-name": "Ellipse 281",
    cx: 7.74,
    cy: 7.74,
    rx: 7.74,
    ry: 7.74,
    transform: "translate(-1202.505 1036.726)",
    fill: "none",
    stroke: "#bf085b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_308",
    "data-name": "Ellipse 308",
    cx: 4.04,
    cy: 4.04,
    rx: 4.04,
    ry: 4.04,
    transform: "translate(-1130.648 1014.125)",
    fill: "none",
    stroke: "#bf085b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_282",
    "data-name": "Ellipse 282",
    cx: 7.74,
    cy: 7.74,
    rx: 7.74,
    ry: 7.74,
    transform: "translate(-888.006 925.914)",
    fill: "none",
    stroke: "#fda14d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    cx: 7.74,
    cy: 7.74,
    rx: 7.74,
    ry: 7.74,
    transform: "translate(-599.216 1020.99)",
    fill: "none",
    stroke: "#bf085b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 7.74,
    cy: 7.74,
    rx: 7.74,
    ry: 7.74,
    transform: "translate(-524.85 913.929)",
    fill: "none",
    stroke: "#bf085b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_285",
    "data-name": "Ellipse 285",
    cx: 7.74,
    cy: 7.74,
    rx: 7.74,
    ry: 7.74,
    transform: "translate(-253.733 927.066)",
    fill: "none",
    stroke: "#fda14d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36572",
    "data-name": "Path 36572",
    d: "M754.813,288.972A3.817,3.817,0,1,1,751,285.155,3.817,3.817,0,0,1,754.813,288.972Z",
    transform: "translate(-1435.55 732.018)",
    fill: "none",
    stroke: "#bf085b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_286",
    "data-name": "Ellipse 286",
    cx: 3.817,
    cy: 3.817,
    rx: 3.817,
    ry: 3.817,
    transform: "translate(-466.994 998.512)",
    fill: "none",
    stroke: "#fda14d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_287",
    "data-name": "Ellipse 287",
    cx: 3.817,
    cy: 3.817,
    rx: 3.817,
    ry: 3.817,
    transform: "translate(-285.99 995.884)",
    fill: "none",
    stroke: "#fda14d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_288",
    "data-name": "Ellipse 288",
    cx: 3.817,
    cy: 3.817,
    rx: 3.817,
    ry: 3.817,
    transform: "translate(-646.601 929.35) rotate(-78.327)",
    fill: "none",
    stroke: "#bf085b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_289",
    "data-name": "Ellipse 289",
    cx: 3.817,
    cy: 3.817,
    rx: 3.817,
    ry: 3.817,
    transform: "translate(-571.867 987.987)",
    fill: "none",
    stroke: "#bf085b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_290",
    "data-name": "Ellipse 290",
    cx: 3.817,
    cy: 3.817,
    r: 3.817,
    transform: "translate(-735.836 921.539) rotate(-80.758)",
    fill: "none",
    stroke: "#bf085b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_291",
    "data-name": "Ellipse 291",
    cx: 3.817,
    cy: 3.817,
    rx: 3.817,
    ry: 3.817,
    transform: "translate(-750.809 1002.398) rotate(-74.973)",
    fill: "none",
    stroke: "#bf085b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_292",
    "data-name": "Ellipse 292",
    cx: 3.817,
    cy: 3.817,
    r: 3.817,
    transform: "translate(-1148.842 954.542) rotate(-45)",
    fill: "none",
    stroke: "#fda14d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_293",
    "data-name": "Ellipse 293",
    cx: 3.817,
    cy: 3.817,
    r: 3.817,
    transform: "matrix(0.951, -0.308, 0.308, 0.951, -1072.218, 1006.862)",
    fill: "none",
    stroke: "#fda14d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_294",
    "data-name": "Ellipse 294",
    cx: 3.817,
    cy: 3.817,
    rx: 3.817,
    ry: 3.817,
    transform: "translate(-368.452 960.761) rotate(-77.99)",
    fill: "none",
    stroke: "#fda14d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33613",
    "data-name": "Group 33613",
    transform: "translate(-677.038 931.611)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_295",
    "data-name": "Ellipse 295",
    cx: 16.5,
    cy: 7.821,
    rx: 16.5,
    ry: 7.821,
    transform: "translate(0 10.34)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_296",
    "data-name": "Ellipse 296",
    cx: 16.5,
    cy: 7.821,
    rx: 16.5,
    ry: 7.821,
    transform: "translate(1.239 28.187) rotate(-58.666)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    cx: 7.821,
    cy: 16.5,
    rx: 7.821,
    ry: 16.5,
    transform: "translate(1.239 8.134) rotate(-31.334)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    cx: 2.07,
    cy: 2.07,
    r: 2.07,
    transform: "translate(14.43 16.091)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33615",
    "data-name": "Group 33615",
    transform: "translate(-1208.005 970.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36573",
    "data-name": "Path 36573",
    d: "M617.048,579.186a2.787,2.787,0,1,1-2.787-2.787A2.787,2.787,0,0,1,617.048,579.186Z",
    transform: "translate(-611.475 -567.282)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_299",
    "data-name": "Ellipse 299",
    cx: 2.787,
    cy: 2.787,
    r: 2.787,
    transform: "translate(29.825 30.5)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_300",
    "data-name": "Ellipse 300",
    cx: 5.942,
    cy: 5.942,
    rx: 5.942,
    ry: 5.942,
    transform: "translate(16.176 15.67)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33614",
    "data-name": "Group 33614",
    transform: "translate(11.761 11.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36574",
    "data-name": "Path 36574",
    d: "M668.445,593.346l-1.985,3.467-1.049,3.856-3.856,1.049-3.467,1.985-3.468-1.985-3.856-1.049-1.049-3.856-1.985-3.467,1.985-3.468,1.049-3.856,3.856-1.049,3.467-1.985,3.467,1.985,3.856,1.049,1.049,3.856Z",
    transform: "translate(-647.731 -582.989)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36575",
    "data-name": "Path 36575",
    d: "M654.106,593.331a2.784,2.784,0,0,1,4.873-1.843,15.958,15.958,0,1,0-4.139,3.723A2.773,2.773,0,0,1,654.106,593.331Z",
    transform: "translate(-624.28 -560.045)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36576",
    "data-name": "Path 36576",
    d: "M634.648,548.295a21.589,21.589,0,0,0-17.908,9.511,2.785,2.785,0,0,1-2.492,4.966,21.612,21.612,0,1,0,20.4-14.477Z",
    transform: "translate(-612.53 -548.295)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33618",
    "data-name": "Group 33618",
    transform: "translate(-524.85 981.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33617",
    "data-name": "Group 33617",
    transform: "translate(0 23.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33616",
    "data-name": "Group 33616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36577",
    "data-name": "Path 36577",
    d: "M999.151,325.745,988.823,335.9a2.771,2.771,0,0,1-3.917-.033h0a2.77,2.77,0,0,1,.033-3.918l10.328-10.154a2.77,2.77,0,0,1,3.917.033h0A2.77,2.77,0,0,1,999.151,325.745Z",
    transform: "translate(-984.111 -321)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_301",
    "data-name": "Ellipse 301",
    cx: 11.902,
    cy: 11.902,
    rx: 11.902,
    ry: 11.902,
    transform: "translate(15.317)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_302",
    "data-name": "Ellipse 302",
    cx: 8.588,
    cy: 8.588,
    rx: 8.588,
    ry: 8.588,
    transform: "translate(18.632 3.314)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_259",
    "data-name": "Line 259",
    x1: 3.339,
    y2: 3.339,
    transform: "translate(15.464 20.318)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33621",
    "data-name": "Group 33621",
    transform: "translate(-1101.398 919.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33620",
    "data-name": "Group 33620",
    transform: "translate(20.047 44.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33619",
    "data-name": "Group 33619",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2200",
    "data-name": "Rectangle 2200",
    d: "M3.9,0H11.33a3.9,3.9,0,0,1,3.9,3.9v.315a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.9A3.9,3.9,0,0,1,3.9,0Z",
    transform: "translate(0 3.425) rotate(-13)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_303",
    "data-name": "Ellipse 303",
    cx: 15.212,
    cy: 15.212,
    r: 15.212,
    transform: "matrix(0.778, -0.628, 0.628, 0.778, 0, 19.097)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36578",
    "data-name": "Path 36578",
    d: "M1073.22,681.07l-14.189-26.914-1.772-3.267a18.929,18.929,0,1,0,17.655,33.49l-1.733-3.288",
    transform: "translate(-1044.735 -646.222)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    cx: 9.509,
    cy: 3.342,
    rx: 9.509,
    ry: 3.342,
    transform: "translate(5.885 12.369) rotate(-27.798)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36579",
    "data-name": "Path 36579",
    d: "M1097.572,730.551a15.2,15.2,0,0,0,16.823-8.869,15.2,15.2,0,0,0-16.823,8.869Z",
    transform: "translate(-1079.057 -694.225)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_305",
    "data-name": "Ellipse 305",
    cx: 7.606,
    cy: 15.212,
    rx: 7.606,
    ry: 15.212,
    transform: "translate(7.568 11.481) rotate(-27.798)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    y1: 14.189,
    x2: 26.914,
    transform: "translate(7.934 14.297)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    x2: 1.571,
    y2: 6.552,
    transform: "translate(25.809 39.813)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262",
    "data-name": "Line 262",
    y1: 4.537,
    x2: 18.916,
    transform: "translate(19.211 48.285)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33626",
    "data-name": "Group 33626",
    transform: "translate(-439.777 944.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36580",
    "data-name": "Path 36580",
    d: "M1073.953,92.8a1.864,1.864,0,1,1-2.487-.873A1.864,1.864,0,0,1,1073.953,92.8Z",
    transform: "translate(-1070.408 -81.005)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36581",
    "data-name": "Path 36581",
    d: "M1084.6,64.823a1.864,1.864,0,1,1-2.487-.873A1.864,1.864,0,0,1,1084.6,64.823Z",
    transform: "translate(-1077.667 -61.927)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36582",
    "data-name": "Path 36582",
    d: "M1157.777,59.045a1.864,1.864,0,1,1-2.487-.873A1.864,1.864,0,0,1,1157.777,59.045Z",
    transform: "translate(-1127.573 -57.987)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33623",
    "data-name": "Group 33623",
    transform: "translate(2.609 14.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33622",
    "data-name": "Group 33622",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2201",
    "data-name": "Rectangle 2201",
    width: 13.101,
    height: 3.625,
    rx: 1.812,
    transform: "translate(0 5.571) rotate(-25.165)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36583",
    "data-name": "Path 36583",
    d: "M1102.558,126.717,1097.7,116.6l-7.863,3.776,4.861,10.121,3.065,16.932a4.22,4.22,0,0,0,5.631,1.977l8.49-4.077a4.22,4.22,0,0,0,1.977-5.631Z",
    transform: "translate(-1086.265 -112.388)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36584",
    "data-name": "Path 36584",
    d: "M1109.462,170.885s1.621-2.627,5.933-2.478a4.777,4.777,0,0,0,5.036-3.779",
    transform: "translate(-1099.65 -145.144)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33625",
    "data-name": "Group 33625",
    transform: "translate(22.806 4.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33624",
    "data-name": "Group 33624",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2202",
    "data-name": "Rectangle 2202",
    width: 13.101,
    height: 3.625,
    rx: 1.812,
    transform: "matrix(0.905, -0.425, 0.425, 0.905, 0, 5.571)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36585",
    "data-name": "Path 36585",
    d: "M1165.371,114.928a4.362,4.362,0,1,0,7.864-3.776L1161.2,86.1l-7.863,3.776Z",
    transform: "translate(-1149.77 -81.891)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36586",
    "data-name": "Path 36586",
    d: "M1165.371,114.928a4.362,4.362,0,1,0,7.864-3.776L1161.2,86.1l-7.863,3.776Z",
    transform: "translate(-1149.77 -81.891)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36587",
    "data-name": "Path 36587",
    d: "M1177.983,143.532a7.6,7.6,0,0,1,4.449-1.1,4.693,4.693,0,0,0,3.94-1.589",
    transform: "translate(-1166.576 -119.228)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33627",
    "data-name": "Group 33627",
    transform: "translate(-979.19 992.513)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2203",
    "data-name": "Rectangle 2203",
    width: 44.829,
    height: 33.075,
    rx: 16.209,
    transform: "translate(9.466 0) rotate(16.63)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_263",
    "data-name": "Line 263",
    x2: 42.954,
    y2: 12.829,
    transform: "translate(2.14 24.527)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36588",
    "data-name": "Path 36588",
    d: "M644.823,225.845a1.168,1.168,0,1,1-.785-1.453A1.168,1.168,0,0,1,644.823,225.845Z",
    transform: "translate(-621.101 -191.175)",
    fill: "#fff",
    stroke: "#9b9b9b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2204",
    "data-name": "Rectangle 2204",
    width: 10.05,
    height: 4.532,
    transform: "translate(16.662 36.669) rotate(16.63)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_264",
    "data-name": "Line 264",
    x2: 16.623,
    y2: 4.965,
    transform: "translate(11.799 40.2)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33631",
    "data-name": "Group 33631",
    transform: "translate(-295.342 933.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33628",
    "data-name": "Group 33628",
    transform: "translate(9.078 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2205",
    "data-name": "Rectangle 2205",
    width: 8.813,
    height: 36.332,
    transform: "translate(0 3.836) rotate(-25.804)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_265",
    "data-name": "Line 265",
    x1: 3.967,
    y2: 1.918,
    transform: "translate(5.864 3.923)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    x1: 3.967,
    y2: 1.918,
    transform: "translate(9.528 11.502)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    x1: 3.967,
    y2: 1.918,
    transform: "translate(13.192 19.081)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_268",
    "data-name": "Line 268",
    x1: 3.967,
    y2: 1.918,
    transform: "translate(16.857 26.659)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_269",
    "data-name": "Line 269",
    x1: 1.984,
    y2: 0.959,
    transform: "translate(9.06 6.432)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    x1: 1.983,
    y2: 0.959,
    transform: "translate(10.286 8.967)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    x1: 1.983,
    y2: 0.959,
    transform: "translate(12.731 14.024)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    x1: 1.983,
    y2: 0.959,
    transform: "translate(13.957 16.559)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273",
    "data-name": "Line 273",
    x1: 1.983,
    y2: 0.959,
    transform: "translate(16.402 21.616)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    x1: 1.983,
    y2: 0.959,
    transform: "translate(17.627 24.151)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33630",
    "data-name": "Group 33630",
    transform: "translate(0 7.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33629",
    "data-name": "Group 33629",
    transform: "translate(3.642 6.432)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_275",
    "data-name": "Line 275",
    x1: 2.379,
    y2: 1.15,
    transform: "translate(1.262 5.07)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    x1: 2.379,
    y2: 1.15,
    transform: "translate(4.926 12.649)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    x1: 2.379,
    y2: 1.15,
    transform: "translate(8.59 20.228)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    x1: 1.19,
    y2: 0.575,
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    x1: 1.19,
    y2: 0.575,
    transform: "translate(1.226 2.535)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280",
    "data-name": "Line 280",
    x1: 1.19,
    y2: 0.575,
    transform: "translate(3.671 7.592)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    x1: 1.19,
    y2: 0.575,
    transform: "translate(4.896 10.127)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    x1: 1.19,
    y2: 0.575,
    transform: "translate(7.341 15.184)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    x1: 1.19,
    y2: 0.575,
    transform: "translate(11.066 22.887)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x1: 1.19,
    y2: 0.575,
    transform: "translate(8.567 17.719)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36589",
    "data-name": "Path 36589",
    d: "M774.8,352.678l1.722-41.188L792.342,344.2Z",
    transform: "translate(-774.805 -311.49)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36590",
    "data-name": "Path 36590",
    d: "M795.343,399.988l.471-11.266,4.326,8.947Z",
    transform: "translate(-789.679 -367.423)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33634",
    "data-name": "Group 33634",
    transform: "translate(-725.289 972.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33633",
    "data-name": "Group 33633",
    transform: "translate(4.268 4.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33632",
    "data-name": "Group 33632",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2206",
    "data-name": "Rectangle 2206",
    width: 11.426,
    height: 31.657,
    transform: "translate(30.464 22.385) rotate(135)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_36591",
    "data-name": "Path 36591",
    d: "M902.555,721.178l-2.187-10.266-8.079,8.079Z",
    transform: "translate(-865.636 -684.258)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    x1: 3.771,
    y2: 3.771,
    transform: "translate(32.127 32.127)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2207",
    "data-name": "Rectangle 2207",
    d: "M0,0H11.425a0,0,0,0,1,0,0V.323A5.713,5.713,0,0,1,5.713,6.036h0A5.713,5.713,0,0,1,0,.323V0A0,0,0,0,1,0,0Z",
    transform: "matrix(-0.707, 0.707, -0.707, -0.707, 12.347, 4.268)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    x1: 8.079,
    y2: 8.079,
    transform: "translate(6.45 6.45)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    x1: 20.203,
    y1: 20.203,
    transform: "translate(10.49 10.49)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCourseBackground);
export default __webpack_public_path__ + "static/media/myCourseBackground.78eadc71770f8f2a7ce9b56abebb4e5a.svg";
export { ForwardRef as ReactComponent };